import { render } from "./AmountSelector.vue?vue&type=template&id=5b8e33c3"
import script from "./AmountSelector.vue?vue&type=script&lang=js"
export * from "./AmountSelector.vue?vue&type=script&lang=js"

import "./AmountSelector.vue?vue&type=style&index=0&id=5b8e33c3&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__